import React from 'react';
import './acercade.css';
import { getbyID } from "../../modules/datafunction";
import { acercade } from "../../modules/data";
import {container,card} from "../../modules/primecompo";

const getitem0=()=>{
const adata=getbyID({item:0},acercade)
const content0= 
    <div>
        <h1>{adata['title']} </h1>
    </div>
return(container(content0,"row0"))    
}

const getitem1=()=>{
const adata=getbyID({item:1},acercade)
const content0= 
    <div>
        <p>{adata['p']}</p> 
    </div>;
const content1=
    <div>
        <h3>{adata['title1']}</h3>
        <p>{adata['p1']}</p>
    </div>
const content2=
    <div>
        <h3>{adata['title2']}</h3>
        <p>{adata['p2']}</p>
    </div>  
const wrapper=container(content0,"row0")
const wrapper2=card(content1,content2,"row0","row0")   
    return(
        [wrapper,wrapper2] 
    )
    


}

const getitem2=()=>{
const adata=getbyID({item:2},acercade)
const content0= 
   <img   alt="Telefono" src={adata['img']} />
const content1=
    <div>
        <h3>{adata['span']}</h3>
        <ul>
            <li>{adata['l0']}</li>
            <li>{adata['l1']}</li>
            <li>{adata['l2']}</li>
            <li>{adata['l3']}</li>
            <li>{adata['l4']}</li>
            <li>{adata['l5']}</li>
            <li>{adata['l6']}</li>

        </ul>

    </div>   

    return(
        <div> {[content0,content1]}   </div>
        
    )
}


const Acercade=()=>{
    return(
        <div className="acercade">
            {getitem0()}
            {getitem1()}
            {getitem2()}
        </div>
    )
}


export default Acercade;




